import { useNavigate } from "react-router-dom";

export default function SafetySection() {
  const navigate = useNavigate();

  const tips = [
    {
      icon: "ri-user-search-line",
      title: "Always Verify Sellers",
      desc: "Check seller ratings and review history before making any purchase. Our spreadsheet highlights trusted sellers with proven track records.",
    },
    {
      icon: "ri-scales-line",
      title: "Compare Prices",
      desc: "Use the price comparison data in the spreadsheet to ensure you are getting the best deal across multiple verified sellers.",
    },
    {
      icon: "ri-bank-card-line",
      title: "Use Secure Payment Methods",
      desc: "Always use payment methods that offer buyer protection. Never send direct transfers to unverified sellers.",
    },
    {
      icon: "ri-ship-line",
      title: "Understand Shipping Regulations",
      desc: "Review shipping policies, customs fees, and delivery estimates before placing orders to avoid unexpected costs.",
    },
    {
      icon: "ri-search-line",
      title: "Research Before Purchasing",
      desc: "Take time to read product descriptions, check size charts, and review community feedback before clicking buy.",
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Safety First
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            How to Shop Safely
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Follow these essential tips to ensure a secure and satisfying shopping experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {tips.map((tip, idx) => (
            <div
              key={tip.title}
              className="flex gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors duration-200"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center text-primary-600 flex-shrink-0 mt-0.5">
                <span className="text-xs font-bold">{idx + 1}</span>
              </div>
              <div>
                <h3 className="font-semibold text-foreground-900 text-sm mb-1.5">{tip.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{tip.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => navigate("/best-allchinabuy-spreadsheet-guide")}
            className="inline-flex items-center gap-2 text-primary-600 font-semibold text-sm hover:text-primary-700 transition-colors duration-200 group cursor-pointer"
          >
            <span>Read Our Complete Safety Guide</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
          </button>
        </div>
      </div>
    </section>
  );
}